module.exports = __webpack_public_path__ + "img/app-store.21aaeb28.svg";